import { axios } from '@/vue/utils/request'

const api = {
  getForeclosureApplyList: '/foreclosure/getForeclosureApplyList',
  getForeclosureApplyInfo: '/foreclosure/getForeclosureApplyInfo',
  getForeClousureList: '/foreclosure/getForeClousureList',
  getComments: '/foreclosure/getAuditListByApplyId',
  workflow: '/foreclosure/workflow',
  repayPlanInNotPrincipal: '/foreclosure/repayPlanInNotPrincipal',
  repayPlan: '/foreclosure/repayPlan',
  getTodos: '/foreclosure/getTodos',
  getLoanTodos: '/mortgage/list',
  getApplyInfo: '/mortgage/getApplyInfo',
  getApplyData: '/mortgage/applyData',
  getDueDiligence: '/mortgage/getDueDiligence',
  getFiles: '/mortgage/file/getFiles',
  getOssFiles: '/mortgage/fileOss/getFiles',
  delFile: '/mortgage/file/delFile',
  uploads: '/mortgage/uploads',
  ossUploads: '/mortgage/oss/uploads',
  addDueDiligence: '/mortgage/addDueDiligence',
  auditProcess: '/mortgage/audit',  //审批入口
  hangApplyProcess: '/mortgage/hangApply',
  creditFinal: '/mortgage/creditFinal',
  endCreditView: '/mortgage/endCredit',
  rejectProcess: '/mortgage/audit/rejectProcess',  //跳转驳回
  updateContractNo: '/mortgage/updateContractNo',
  savePreSignContract: '/mortgage/savePreSignContract',
  saveExpirationDate: '/mortgage/saveExpirationDate',
  mortgageRepayPlan: '/mortgage/repayPlan',
  addHandle: '/mortgage/addHandle',
  getHandle: '/mortgage/getHandle',
  getUsers: '/mortgage/user/getList',
  suitableProduct:'/product/instance/apply/list', //匹配产品
  saveInterview: '/businessInfo/saveInterview',
  getInterviewByApplyId: '/businessInfo/getInterviewByApplyId',
  getSupplierTree:'/product/getSupplierTree',
  getCapitalListByCompany: '/product/capital/getListByCompany',
  getSupplierProduct: '/product/supplier/product/getList',
  houses:'/mortgage/houses',
  saveCustomerHouse: '/customer/house/save',

}

export function getInterviewByApplyId(params) {
    return axios({
        url: api.getInterviewByApplyId,
        method: 'get',
        params: params
    })
}

export function saveInterview(params) {
    return axios({
        url: api.saveInterview,
        method: 'post',
        data: params
    })
}

export function getUsers(params) {
    return axios({
        url: api.getUsers,
        method: 'get',
        params: params
    })
}

export function getHandle(params) {
    return axios({
        url: api.getHandle,
        method: 'get',
        params: params
    })
}

export function addHandle(params) {
    return axios({
        url: api.addHandle,
        method: 'post',
        data: params
    })
}

export function mortgageRepayPlan(params) {
    return axios({
        url: api.mortgageRepayPlan,
        method: 'get',
        params: params
    })
}

export function saveExpirationDate(params) {
    return axios({
        url: api.saveExpirationDate,
        method: 'get',
        params: params
    })
}

export function savePreSignContract(params) {
    return axios({
        url: api.savePreSignContract,
        method: 'get',
        params: params
    })
}
export function updateContractNo(params) {
    return axios({
        url: api.updateContractNo,
        method: 'post',
        data: params
    })
}

export function rejectProcess(params) {
    return axios({
        url: api.rejectProcess,
        method: 'post',
        params: params
    })
}

export function endCreditView(params) {
    return axios({
        url: api.endCreditView,
        method: 'get',
        params: params
    })
}


export function hangApplyProcess(params) {
    return axios({
        url: api.hangApplyProcess + "/" + params.process,
        method: 'get',
        params: params
    })
}

export function auditProcess(params) {
    return axios({
        url: api.auditProcess,
        method: 'get',
        params: params
    })
}
export function addDueDiligence(params) {
    return axios({
        url: api.addDueDiligence,
        method: 'post',
        data: params
    })
}

export function saveCreditFinal(params) {
    return axios({
        url: api.creditFinal,
        method: 'post',
        data: params
    })
}

export function getCreditFinal(params) {
    return axios({
        url: api.creditFinal,
        method: 'get',
        params: params
    })
}

export function ossUploads(params) {
    return axios({
        url: api.ossUploads,
        method: 'post',
        data: params
    })
}

export function uploads(params) {
    return axios({
        url: api.uploads,
        method: 'post',
        data: params
    })
}

export function getApplyData(params) {
    return axios({
        url: api.getApplyData,
        method: 'post',
        data: params
    })
}

export function getTodos() {
    return axios({
        url: api.getTodos,
        method: 'get'
    })
}

export function getFiles(params) {
    return axios({
        url: api.getFiles,
        method: 'get',
        params: params
    })
}

export function getOssFiles(params) {
    return axios({
        url: api.getOssFiles,
        method: 'get',
        params: params
    })
}

export function delFile(params) {
    return axios({
        url: api.delFile,
        method: 'get',
        params: params
    })
}

export function getDueDiligence(params) {
    return axios({
        url: api.getDueDiligence,
        method: 'get',
        params: params
    })
}

export function getApplyInfo(params) {
    return axios({
        url: api.getApplyInfo,
        method: 'get',
        params: params
    })
}

export function getLoanTodos(params) {
    return axios({
        url: api.getLoanTodos,
        method: 'get',
        params: params
    })
}

export function getForeClousureFileList(params) {
  return axios({
    url: api.getForeClousureList,
    method: 'get',
    params: params
  })
}

export function getForeclosureApplyList(params) {
  return axios({
    url: api.getForeclosureApplyList,
    method: 'get',
    params: params
  })
}

export function getForeclosureApplyInfo(params) {
  return axios({
    url: api.getForeclosureApplyInfo,
    method: 'get',
    params: params
  })
}

export function getComments(params) {
    return axios({
        url: api.getComments,
        method: 'get',
        params: params
    })
}

export function repayPlan(params) {
    return axios({
        url: api.repayPlan,
        method: 'get',
        params: params
    })
}
export function repayPlanInNotPrincipal(params) {
    return axios({
        url: api.repayPlanInNotPrincipal,
        method: 'get',
        params: params
    })
}

export function workflow(params) {
    return axios({
        url: api.workflow,
        method: 'post',
        data: params
    })
}


export function getSupplierTree(params) {
    return axios({
        url: api.getSupplierTree,
        method: 'get',
        params: params
    })
}

export function getCapitalListByCompany(params) {
    return axios({
        url: api.getCapitalListByCompany,
        method: 'get',
        params: params
    })
}

export function getSupplierProduct(params) {
    return axios({
        url: api.getSupplierProduct,
        method: 'get',
        params: params
    })
    
}
export function getSuitableProduct(params) {
    return axios({
        url: api.suitableProduct,
        method: 'get',
        params: params
    })
}

export function getApplyInfoHouses(params) {
    return axios({
        url: api.houses,
        method: 'get',
        params: params
    })
}

export function getHouseInfo(customerHouseId) {
    return axios({
        url: api.houses+'/'+customerHouseId,
        method: 'get',
    })
}

export function saveCustomerHouse(parameter) {
    return axios({
        url: api.saveCustomerHouse,
        method: 'post',
        data: parameter
    })
}




